import { useContext } from "react";
import { PaginationContext } from "../../utils/ctx/PaginationContext";

interface PaginationType {
  maxPages: number,
};

const Pagination = ({ maxPages }: PaginationType) => {
  const context = useContext(PaginationContext);
  const currentPage = parseInt(String(context.currentPage || 0), 10);

  return (
    <nav className="flex justify-center">
      <PaginationItem page={1} />
      {
        currentPage > 3 && <div>...</div>
      }
      {
        currentPage > 2 &&
        <PaginationItem page={currentPage - 1} />
      }
      {currentPage !== 1 && currentPage !== maxPages && <PaginationItem page={currentPage} />}
      {
        currentPage < maxPages - 1 &&
        <PaginationItem page={currentPage + 1} />
      }
      {
        currentPage < maxPages - 2 && <div>...</div>
      }
      {maxPages > 1 && <PaginationItem page={maxPages} />}
    </nav>
  )
}

const PaginationItem = ({ page }: { page: number }) => {
  const { currentPage, setPage, scrollRef } = useContext(PaginationContext);

  const handleClick = () => {
    // no scrollBehavior: "smooth" bc of safari >:(
    if (scrollRef.current) {
      window.scrollTo(0, scrollRef.current.offsetTop || 0);
      setPage(page);
    }
  }

  return (
    <li className={`list-none border border-primary h-10 w-10 ${page == currentPage ? 'bg-gray' : 'bg-white'} mx-6`}>
      <button
        type="button"
        className="h-10 w-10 text-center font-cirka font-bold text-primary"
        onClick={handleClick}
      >
        {page}
      </button>
    </li>
  )
}

export default Pagination;
